module.exports = __webpack_public_path__ + "img/funnel-fill.6df4c143.svg";